export var CONFLUENCE_ITEM_ENTITIES = ['ati:cloud:confluence:page', 'ati:cloud:confluence:attachment', 'ati:cloud:confluence:blogpost'];
var SEARCH_QUERY = "\nquery($query: String, $entities:[String!]!, $locations: [String!]!, $confluenceFilters: SearchConfluenceFilter, $experience: String!){\n  search{\n    search(\n      query: $query\n      filters: {entities: $entities, locations: $locations, confluenceFilters: $confluenceFilters}\n      analytics: {searchSessionId: \"graphql\"}\n      experience: $experience\n    ) {\n      edges {\n        node {\n          id\n          title\n          url\n          description\n          type\n          lastModifiedDate\n          __typename\n          ... on SearchConfluencePageBlogAttachment {\n            type\n            space {\n              key\n              iconUrl\n            }\n          }\n        }\n      }\n    }\n  }\n}";
var sitesToLocations = function sitesToLocations(sites, cloudId) {
  var cloudIds = sites.length > 0 ? sites : [cloudId];
  var locations = cloudIds.map(function (cloudId) {
    return "ari:cloud:confluence::site/".concat(cloudId);
  });
  return locations;
};
var confluenceFilterToGraphQLFilters = function confluenceFilterToGraphQLFilters(filters) {
  return {
    spaceFilter: filters.filter(function (filter) {
      return filter.type === 'space';
    }).map(function (filter) {
      return filter.id;
    }),
    contributorsFilter: filters.filter(function (filter) {
      return filter.type === 'contributor';
    }).map(function (filter) {
      return filter.id;
    })
  };
};
export { sitesToLocations, confluenceFilterToGraphQLFilters, SEARCH_QUERY };